import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import {
  getAMPTier,
  getJaxData,
  getEvidenceCount,
  getHighestCancerType,
} from "../../../../state/selectors/JaxCkbComponent.selectors";
import { getPathogenicityColorByAllNames } from "../../../../common/helpers/Constant";
import tailwindColors from "../../../../../../tailwind.colors";
import isPortal from "../../../../common/helpers/isPortal";

const JAXCKBCard = ({ card, ampTier, jaxData, evidenceCount, cancerType }) => {
  const isClinical = isPortal();
  const disabledCardMessage = !isClinical
    ? "Only available for VarSome Clinical users"
    : undefined;
  const color = ampTier
    ? getPathogenicityColorByAllNames(ampTier)
    : tailwindColors.gray[300];

  return (
    <CardWrapper
      {...card}
      isDisabled={!jaxData}
      color={color}
      disabledCardMessage={disabledCardMessage}
    >
      <div className="tw-flex">
        {ampTier ? (
          <div className="tw-mr-2">
            AMP:{" "}
            <b data-testid="jaxckb-amptier" style={{ color }}>
              {ampTier}
            </b>
          </div>
        ) : null}
        {evidenceCount ? (
          <div>
            Evidence: <b data-testid="jaxckb-evidence-count">{evidenceCount}</b>
          </div>
        ) : null}
      </div>
      {cancerType ? (
        <b className="tw-capitalize" data-testid="jaxckb-cancer-type">
          {cancerType.key}
        </b>
      ) : null}
    </CardWrapper>
  );
};

JAXCKBCard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
  ampTier: PropTypes.string,
  jaxData: PropTypes.shape({}),
  evidenceCount: PropTypes.number,
  cancerType: PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.number,
  }),
};

JAXCKBCard.defaultProps = {
  ampTier: "",
  jaxData: {},
  evidenceCount: 0,
  cancerType: {},
};

const mapStateToProps = (state) => ({
  ampTier: getAMPTier(state),
  jaxData: getJaxData(state),
  evidenceCount: getEvidenceCount(state),
  cancerType: getHighestCancerType(state),
});

export default connect(mapStateToProps)(JAXCKBCard);
